import axios, {AxiosResponse} from "axios";
import {SERVICE_BILL_ENDPOINT, SERVICE_INVOICE_ENDPOINT} from "@/constants/endpoints";
import {
    CreateInvoicePayload, UpdateDraftInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import authHeader from "@/services/auth-header";

class ServiceInvoiceOrchestrator {

    public createInvoice(req: CreateInvoicePayload) {
        return axios.post<void>(`${SERVICE_INVOICE_ENDPOINT}`, req, {headers: authHeader()})
    }

    public createBill(req: CreateInvoicePayload) {
        return axios.post<void>(`${SERVICE_BILL_ENDPOINT}`, req, {headers: authHeader()})
    }

    public deleteDraftInvoice(id: number): Promise<AxiosResponse<void>> {
        return axios.delete<void>(`${SERVICE_INVOICE_ENDPOINT}/draft/${id}`, {headers: authHeader()})
    }

    public draftInvoice(req: CreateInvoicePayload) {
        return axios.post<void>(`${SERVICE_INVOICE_ENDPOINT}/draft`, req, {headers: authHeader()})
    }

    public updateDraftInvoice(req: UpdateDraftInvoicePayload) {
        return axios.put<void>(`${SERVICE_INVOICE_ENDPOINT}/draft`, req, {headers: authHeader()})
    }

    public publishInvoice(req: { id: number, payeeId: number }) {
        return axios.put<void>(`${SERVICE_INVOICE_ENDPOINT}/draft/publish`, req, {headers: authHeader()})
    }


}

export default new ServiceInvoiceOrchestrator()